import React from "react";

function LegalNoticePage() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.5",
  };

  const headingStyle = {
    marginTop: "2rem",
    marginBottom: "1rem",
    fontSize: "1.3rem",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h1>Mentions légales</h1>

      <h2 style={headingStyle}>Légal</h2>
      <p>
        <strong>Crédits</strong>
        <br />
        Concept et production&nbsp;:
      </p>
      <p>
        Ce magasin en ligne a été créé en utilisant le logiciel de panier d’achat <strong>PrestaShop</strong>, 
        consultez le blog sur le commerce électronique de PrestaShop pour des 
        actualités et des conseils sur la vente en ligne et la gestion de votre site 
        de commerce électronique.
      </p>

      <h2 style={headingStyle}>Éditeur du site</h2>
      <p>
        Le site <strong>www.balteemobility.com</strong> est édité par <strong>Baltee Mobility</strong> :<br />
        <strong>Entreprise&nbsp;:</strong> SAS Baltee <br />
        <strong>Siège social&nbsp;:</strong> BALTEE, PLACE DU GRANIER 35135 CHANTEPIE <br />
        <strong>SIRET&nbsp;:</strong> 91334069100017<br />
        <strong>Numéro de TVA&nbsp;:</strong> FR35913340691 <br />
        <strong>Contact&nbsp;:</strong> contact@baltee.com
      </p>

      <h2 style={headingStyle}>Hébergement du site</h2>
      <p>
        Le site <strong>www.balteemobility.com</strong> est hébergé par&nbsp;:  
        <br />
        <strong>Amazon Web Services (AWS)</strong>
        <br />
        Adresse&nbsp;: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA 98109-5210, États-Unis.
        <br />
        Site web&nbsp;: <a href="https://aws.amazon.com">https://aws.amazon.com</a>
      </p>

      <h2 style={headingStyle}>Propriété intellectuelle</h2>
      <p>
        Tous les contenus présents sur le site <strong>www.balteemobility.com</strong> (textes, 
        images, vidéos, logos etc.) sont la propriété exclusive de Baltee Mobility ou 
        de leurs auteurs respectifs. Toute reproduction, distribution, modification, 
        ou utilisation sans autorisation préalable est interdite.
      </p>

      <h2 style={headingStyle}>Données personnelles</h2>
      <p>
        Les informations recueillies sur ce site sont utilisées pour la gestion des 
        commandes et la relation client. Elles peuvent être partagées avec des 
        partenaires et prestataires techniques dans le cadre du bon fonctionnement 
        du service.
      </p>
      <p>
        Conformément à la loi Informatique et Libertés du 6 janvier 1978 et au RGPD 
        (Règlement Général sur la Protection des Données), vous disposez d'un droit 
        d'accès, de rectification, de suppression et d'opposition aux données 
        personnelles vous concernant. Pour exercer ce droit, veuillez nous contacter 
        à l'adresse suivante : [adresse e-mail de contact].
      </p>

      <h2 style={headingStyle}>Cookies</h2>
      <p>
        Le site <strong>www.balteemobility.com</strong> utilise des cookies pour 
        améliorer l'expérience utilisateur, analyser le trafic et personnaliser 
        les contenus. Vous pouvez configurer votre navigateur pour refuser 
        l’utilisation de ces cookies.
      </p>

      <h2 style={headingStyle}>Limitation de responsabilité</h2>
      <p>
        Le site <strong>www.balteemobility.com</strong> est un site marchand. Baltee 
        Mobility s’efforce de fournir des informations précises et à jour, mais décline 
        toute responsabilité en cas d'erreurs ou d'omissions. L’éditeur ne saurait être 
        tenu responsable des conséquences liées à l’utilisation du site ou des informations 
        qu’il contient.
      </p>

      <h2 style={headingStyle}>Crédits</h2>
      <p>
        Conception et production&nbsp;: Baltee Mobility
        <br />
        Ce site a été créé à l'aide du logiciel <strong>PrestaShop</strong>.
        <br />
        Consultez le blog PrestaShop pour rester informé des dernières nouvelles 
        et obtenir des conseils sur la gestion d’un site d’e-commerce.
      </p>

      <h2 style={headingStyle}>Loi applicable</h2>
      <p>
        Les présentes mentions légales sont régies par la loi française. En cas 
        de litige et après tentative de recherche d’une solution amiable, les 
        tribunaux français seront seuls compétents pour connaître de ce litige.
      </p>
    </div>
  );
}

export default LegalNoticePage;
